import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioInputFn = /* @__PURE__ */ createRecipe('radio-input', {}, [])

const radioInputVariantMap = {}

const radioInputVariantKeys = Object.keys(radioInputVariantMap)

export const radioInput = /* @__PURE__ */ Object.assign(memo(radioInputFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioInput',
  __getCompoundVariantCss__: radioInputFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioInputVariantKeys,
  variantMap: radioInputVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioInputVariantKeys)
  },
  getVariantProps: radioInputFn.getVariantProps,
})